import { researchProject } from '@stereoagency/sanity-schema';

const orderedBuilder = researchProject.schema.builder.orderBy(
  'datetime',
  'desc'
) as typeof researchProject.schema.builder;

export const relatedResearchProjectsQuery = orderedBuilder
  .filter('_id != ^._id && count(taxonomies[_ref in ^.taxonomies[]._ref]) > 0')
  .pick(['_id', 'datetime', 'slug', 'title', 'introduction'])
  .map((resolver) => ({
    author: resolver.author.resolve(['_id', 'name', 'firstName']).use(),
    taxonomies: resolver.taxonomies
      .resolveIn(['_id', 'type', 'slug', 'name'])
      .use()
  }))
  .select(0, 3, true)
  .use();

export const researchProjectPageQuery = researchProject.schema.builder
  .filter('slug.current == $slug')
  .pick(['_id', 'datetime', 'slug', 'title', 'introduction', 'content'])
  .map((resolver) => ({
    author: resolver.author.resolve(['_id', 'name', 'firstName']).use(),
    taxonomies: resolver.taxonomies
      .resolveIn(['_id', 'type', 'slug', 'name'])
      .use()
  }))
  .subquery({
    relatedResearchProjects: relatedResearchProjectsQuery
  })
  .first()
  .use();

export const researchProjectPageLinkedResearchContentQuery =
  researchProject.schema.builder
    .filter('slug.current == $slug')
    .pick(['_id'])
    .map((resolver) => ({
      linkedResearchContent: resolver.linkedResearchContent
        .resolve(['_id', '_type', 'slug', 'title'])
        .use()
    }))
    .first()
    .use();

export const researchProjectByIdQuery = researchProject.schema.builder
  .filter('_id == $id')
  .pick(['_id', 'datetime', 'title', 'introduction', 'content'])
  .map((resolver) => ({
    taxonomies: resolver.taxonomies
      .resolveIn(['_id', 'type', 'slug', 'name'])
      .use()
  }))
  .subquery({
    relatedResearchProjects: relatedResearchProjectsQuery
  })
  .first()
  .use();
